import {makeStyles} from '@material-ui/core/styles'
import {colores, tipografia, estilosTextosPrincipales} from '../../../AppStyle'

export const customStyle = makeStyles ({
 
    // Bloques Principales

    gridSeccionUno:{
        width: '100%',
        height: '32px',
        backgroundColor: colores.escalaGrises.cien
    },
    gridSeccionDos:{
        width: '100%',
        height: '168px',
    },
    gridSeccionDosPhone:{
        width: '100%',
        paddingBottom: '10px',
        marginTop: '10px',
        marginBottom: '15px',
        boxShadow: '0px 10px 19px -6px #787D80'
    },
    gridSeccionTres:{
        width: '100%',
        height: '48px',
        backgroundColor: colores.principales.principal
    },

    // Bloques Secundarios

    gridSeccionTresTitulos:{
        width: 'fit-content',
        height: 'inherit',
        marginLeft: '5%'
    },
    gridSeccionDosArriba:{
        width: 'inherit',
        height: '62%',
        borderBottom: `1px solid ${colores.escalaGrises.diez}`
    },
    gridSeccionDosArribaPhone:{
        width: 'inherit',
        height: '62%'
    },
    gridSeccionDosAbajo:{
        width: 'inherit',
        height: '38%',
    },
    gridSeccionUnoContacto:{
        width:'fit-content',
        height: '20px',
        paddingRight: '25px',
        marginRight: '25px',
        borderRight: '1px solid ' + colores.escalaGrises.ochenta   
    },
    gridSeccionUnoRRSS:{
        width:'fit-content',
        marginRight:'5%'
    },

    // Resto de Bloques

    gridSeccionDosAbajoBreadcrumbs:{
        width: 'auto',
        maxWidth: '60%',
        marginLeft: '5%'
    },
    gridSeccionDosAbajoDerecha:{
        width: 'auto',
        maxWidth: '30%',
        marginRight: '5%',
        maxWidth: '40%'
    },
    gridSeccionDosArribaJA:{
        width: 'fit-content',
        marginLeft: '5%'
    },
    gridLogoJA:{
        width: 'fit-content',
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    gridOvTexto:{
        paddingRight: '10px',
        borderRight: '1px solid white',
        marginRight: '10px'
    },

    // Elementos Franja Verde
    ovTexto:{
        ...estilosTextosPrincipales.encabezadoH1,
        fontWeight: 'normal',
        color: colores.escalaGrises.cero
    },
    consejeriaTexto:{
        fontFamily: tipografia.regular,
        fontSize: '17px',
        lineHeight: '24px',
        color: colores.escalaGrises.cero
    },

    // Elementos Franja Blanca

    botonHome:{
        background: 'transparent',
        border: 'none',
    },
    botonCabecera:{
        height: '48px',
        width: '175px',
        border: '1px solid',
        borderRadius: '4px',
        color: colores.escalaGrises.cero,
        fontFamily: tipografia.bold,
        fontSize: '12px',
        lineHeight: '16px',
        backgroundColor: colores.principales.principal,     
    },
    telefono:{
        ...estilosTextosPrincipales.body1,
        fontWeight: '600',
        color: colores.escalaGrises.cien,
        marginRight: '35px'
    },
    ayuda: {
        marginRight: '20px',
    },
    iconoTelefono:{
        marginRight: '10px',
        height: '24px'
    },
    iconoJA:{
        width: '382px',
        cursor: 'pointer'
    },
    iconoJAPhone:{
        height:'40px',
        borderRadius: '6px',
        marginRight: '10px'
    },

    // Elementos Franja Negra    
    gridContacto: {
        alignItems: 'self-end'
    },
    textoContacto: {
        fontFamily: tipografia.regular,
        fontSize: '12px',
        color: colores.escalaGrises.cero,
        cursor: 'pointer',
        opacity: 0.8,
        background: 'transparent' ,
        border: 'none',
        '&:hover':{
            outline: '1px solid ' + colores.escalaGrises.cero,

        },
        '&:focus':{
            outline: '1px solid ' +colores.escalaGrises.cero,
        }
    },
    iconoRRSS:{
        height: '12px',
        opacity: 0.8
    },
    lista:{
        listStyleType: 'none'
    },
    elementoLista:{
        float: 'left'
    },
    iconoAyuda:{
        marginRight: '5px',
        color: colores.escalaGrises.cero,
        height: '15px',            
        opacity: 0.8   
    },
    linkRrss:{
        marginRight: '15px',
        '&:hover':{
            outline: '1px solid ' + colores.escalaGrises.cero,

        },
        '&:focus':{
            outline: '1px solid ' +colores.escalaGrises.cero,
        }
    }, classGridTlf: {
        display: 'flex'
    }
});